<template>
  <Head title="Success Payment" />

  <main class="w-full">
    <Header />

    <div class="bg-gray-100">
      <section
        class="cover bg-blue-teal-gradient relative bg-blue-500 px-4 sm:px-8 lg:px-16 xl:px-40 2xl:px-64 overflow-hidden py-16 flex items-center"
      />
    </div>

    <section class="relative px-4 py-16 sm:px-8 lg:px-16 xl:px-40 2xl:px-64">
      <div class="flex flex-col lg:flex-row lg:-mx-8">
        <div class="w-full lg:px-8">
          <div class="bg-white p-6 mx-auto">
            <svg viewBox="0 0 24 24" class="text-green-600 w-16 h-16 mx-auto my-6">
              <path
                fill="currentColor"
                d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
              />
            </svg>
            <div class="text-center">
              <h3 class="md:text-2xl text-base text-gray-900 font-semibold text-center">Pagamento riuscito!</h3>
              <p class="text-gray-600 my-2">Grazie per aver aquistato i biglietti. Riceverai una mail a breve.</p>
              <p class="text-gray-600"> Buona giornata!</p>
              <div class="py-10 text-center">
                <a href="/" class="px-12 bg-blue-600 hover:bg-blue-500 text-white font-semibold py-3 rounded">
                  Home
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </main>
</template>

<script>
import Footer from "@/Pages/Home/Shared/Footer.vue";
import Header from "@/Pages/Home/Shared/Header.vue";
import { Head } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Footer,
    Header,
    Head,
  },
  methods: {},
};
</script>

<style>

</style>
